module.exports = Zepto;


//////////////////
// WEBPACK FOOTER
// external "Zepto"
// module id = 7
// module chunks = 153